import { render } from "./ProjectScreenSliderNew.vue?vue&type=template&id=638f3384&scoped=true"
import script from "./ProjectScreenSliderNew.vue?vue&type=script&lang=js"
export * from "./ProjectScreenSliderNew.vue?vue&type=script&lang=js"

import "./ProjectScreenSliderNew.vue?vue&type=style&index=0&id=638f3384&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638f3384"]])

export default __exports__